/**
 * Utility functions for User Roles and Approval Workflow
 * Level 3 (DSO)            -> "pass_by_dso"
 * Level 4 (Admin Checker)  -> "pass_by_admin_checker"
 * Level 2 (Super Admin)    -> "pass" (Final Approval)
 */

const getUserLevel = (user, loginDetails) => {
  if (user?.user_level !== undefined && user?.user_level !== null && user?.user_level !== "") {
    return Number(user.user_level);
  }
  // Safe fallback if user state is temporarily null during page refresh
  try {
    const details = loginDetails || (typeof window !== "undefined" ? JSON.parse(localStorage.getItem("login_Details")) : null);
    return Number(details?.user?.user_level || details?.user_level);
  } catch (e) {
    return null;
  }
};

export const isUserAdminChecker = (user, loginDetails) => {
  const level = getUserLevel(user, loginDetails);
  if (level === 4) return true;

  try {
    const details = loginDetails || (typeof window !== "undefined" ? JSON.parse(localStorage.getItem("login_Details")) : null);
    const u = user || details?.user || details;
    const name = String(u?.name || details?.user?.name || "").toLowerCase();
    const roleName = String(u?.role_name || details?.user?.role_name || details?.user?.role || details?.role || "").toLowerCase();
    const roleSlug = String(u?.role_slug || details?.user?.role_slug || "").toLowerCase();
    const email = String(u?.email || details?.user?.email || "").toLowerCase();

    if (
      name.includes("checker") ||
      roleName.includes("checker") ||
      roleSlug.includes("checker") ||
      email.includes("checker")
    ) {
      return true;
    }
  } catch (e) {
    // ignore
  }

  return false;
};

export const isUserDSO = (user, loginDetails) => {
  if (isUserAdminChecker(user, loginDetails)) return false;
  return getUserLevel(user, loginDetails) === 3;
};

export const isUserSuperAdmin = (user, loginDetails) => {
  const level = getUserLevel(user, loginDetails);
  if (level === 2) return true;

  try {
    const details = loginDetails || (typeof window !== "undefined" ? JSON.parse(localStorage.getItem("login_Details")) : null);
    const u = user || details?.user || details;
    const name = String(u?.name || details?.user?.name || "").toLowerCase();
    const roleName = String(u?.role_name || details?.user?.role_name || details?.user?.role || details?.role || "").toLowerCase();
    const roleSlug = String(u?.role_slug || details?.user?.role_slug || "").toLowerCase();

    if (
      name.includes("super admin") ||
      name.includes("superadmin") ||
      roleName.includes("super admin") ||
      roleName.includes("superadmin") ||
      roleSlug.includes("superadmin")
    ) {
      return true;
    }
  } catch (e) {
    // ignore
  }

  return false;
};

export const getApprovalStatusForUser = (user, loginDetails) => {
  if (isUserAdminChecker(user, loginDetails)) {
    return "pass_by_admin_checker";
  }
  if (isUserDSO(user, loginDetails)) {
    return "pass_by_dso";
  }
  return "pass";
};

export const isCompletedStatus = (status) => {
  return ["pass", "reject", "ask_for_resubmit"].includes(status);
};

export const isApplicationProcessedForRole = (status, user, loginDetails) => {
  if (!status) return false;
  const s = String(status).toLowerCase();

  if (isUserAdminChecker(user, loginDetails)) {
    return ["pass_by_admin_checker", "pass", "reject", "ask_for_resubmit"].includes(s);
  }

  if (isUserDSO(user, loginDetails)) {
    return ["pass_by_dso", "pass_by_admin_checker", "pass", "reject", "ask_for_resubmit"].includes(s);
  }

  // Super Admin (Level 2) and default
  return ["pass", "reject", "ask_for_resubmit"].includes(s);
};

